"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDetailPopupState = void 0;
var DetailPopTabType_1 = require("./DetailPopTabType");
exports.defaultDetailPopupState = {
    popActiveTab: DetailPopTabType_1.DetailPopTabType.NONE,
    isMortgageExpand: false,
    isStreeMapDisplay: false,
    nearbyMap: {
        "small": {
            "mapState": {
                "center": {
                    "lat": 22.278905868530273,
                    "lng": 114.13197326660156
                },
                "zoom": 12
            },
            "objects": [],
            "properties": [],
            "popNearbyMore": false,
            "savedPlaces": [],
            "results": [],
            "popNearbyAddPlace": false
        },
        "big": {
            "mapState": {
                "center": {
                    "lat": 22.278905868530273,
                    "lng": 114.13197326660156
                },
                "zoom": 12
            },
            "objects": [],
            "properties": [],
            "popNearbyMore": false,
            "savedPlaces": [],
            "results": [],
            "popNearbyAddPlace": false
        }
    },
    "gallery": {
        "id": "",
        "currentIndex": 0,
        "items": [],
        "showMapView": false,
        "showStreetView": false,
        "t": {
            "mapView": "Map View",
            "streetView": "Street View",
            "soleAgent": "Sole Agent",
            "video": "Videos",
            "virtualTour": "Virtual Tour"
        },
        "showThumbs": false,
        "showFloorPlan": false,
        "showOverlay": false,
        "isSoleAgent": false,
        "banners": []
    },
    "galleryPhotos": {
        "id": "detailgallery",
        "currentIndex": 0,
        "items": [
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/Mount Pokfulam_Terrace.jpg",
                "jpg": "",
                "caption": "Terrace",
                "isPortrait": false
            },
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/Mount Pokfulam_View.jpg",
                "jpg": "",
                "caption": "View",
                "isPortrait": false
            },
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/Mount Pokfulam_Rooftop.jpg",
                "jpg": "",
                "caption": "Rooftop",
                "isPortrait": false
            },
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/Mount Pokfulam_Pool.jpg",
                "jpg": "",
                "caption": "Pool",
                "isPortrait": false
            },
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/Mount Pokfulam_2nd BR.jpg",
                "jpg": "",
                "caption": "2nd BR",
                "isPortrait": false
            },
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/Mount Pokfulam_3rd BR E.jpg",
                "jpg": "",
                "caption": "3rd BR E",
                "isPortrait": false
            },
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/Mount Pokfulam_3rd BR.jpg",
                "jpg": "",
                "caption": "3rd BR",
                "isPortrait": false
            },
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/Mount Pokfulam_4th BR.jpg",
                "jpg": "",
                "caption": "4th BR",
                "isPortrait": false
            },
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/Mount Pokfulam_5th BR.jpg",
                "jpg": "",
                "caption": "5th BR",
                "isPortrait": false
            },
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/Mount Pokfulam_6th BR E.jpg",
                "jpg": "",
                "caption": "6th BR E",
                "isPortrait": false
            },
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/Mount Pokfulam_6th BR.jpg",
                "jpg": "",
                "caption": "6th BR",
                "isPortrait": false
            },
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/Mount Pokfulam_Bathroom 2.jpg",
                "jpg": "",
                "caption": "Bathroom 2",
                "isPortrait": false
            },
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/Mount Pokfulam_Family room.jpg",
                "jpg": "",
                "caption": "",
                "isPortrait": false
            },
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/Mount Pokfulam_KIT.jpg",
                "jpg": "",
                "caption": "",
                "isPortrait": false
            },
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/Mount Pokfulam_LR 2.jpg",
                "jpg": "",
                "caption": "",
                "isPortrait": false
            },
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/Mount Pokfulam_LR.jpg",
                "jpg": "",
                "caption": "",
                "isPortrait": false
            },
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/Mount Pokfulam_MB 2.jpg",
                "jpg": "",
                "caption": "",
                "isPortrait": false
            },
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/Mount Pokfulam_MB E.jpg",
                "jpg": "",
                "caption": "",
                "isPortrait": false
            },
            {
                "type": 3,
                "thumb": "",
                "src": "/NewProperty/mount-pokfulam/mount-pokfulam-logo.jpg",
                "jpg": "",
                "caption": "",
                "isPortrait": false
            }
        ],
        "showMapView": false,
        "showStreetView": false,
        "t": {
            "mapView": "Map View",
            "streetView": "Street View",
            "soleAgent": "Sole Agent",
            "video": "Videos",
            "virtualTour": "Virtual Tour"
        },
        "showThumbs": false,
        "showFloorPlan": false,
        "showOverlay": false,
        "isSoleAgent": false,
        "banners": []
    },
    "defaultAltText": "",
    "galleryFloorPlans": {
        "id": "",
        "currentIndex": 0,
        "items": [],
        "showMapView": false,
        "showStreetView": false,
        "t": {
            "mapView": "Map View",
            "streetView": "Street View",
            "soleAgent": "Sole Agent",
            "video": "Videos",
            "virtualTour": "Virtual Tour"
        },
        "showThumbs": false,
        "showFloorPlan": false,
        "showOverlay": false,
        "isSoleAgent": false,
        "banners": []
    },
    "videoPlayer": {
        "id": "",
        "isPlaying": false,
        "isMuted": true,
        "targetCurrent": 0,
        "totalTime": 0,
        "currentTime": 0,
        "title": "",
        "caption": "",
        "overlayActive": false
    },
    "popNearbyTab": 3,
    "isNearbyEstimatorShowing": false,
    "mortgage": {
        "price": 0,
        "downPayment": 0,
        "interestRate": 3.5,
        "durationInMonth": 360,
        "paymentPerMonth": 0,
        "initialCashOutlay": 0,
        "buyerStampDuty": false,
        "adValoremStampDuty": false,
        "hasOutstandingMortgage": false,
        "stressTestMonthlyIncome": 0,
        "interest": 0,
        "stampDuty": 0,
        "commission": 0,
        "mortgage": 0,
        "amortizeTable": [],
        "rateTable": [],
        "totalExpense": 0,
        "activeIndex": -1,
        "hasTransactedRecently": false,
        "hasTransactedRecentlyMonth": 6,
        "hasTransactedRecentlyMonths": [
            6,
            12,
            36
        ],
        "insurance": 0,
        "error": null
    },
    t: {
        "mapView": "Map View",
        "streetView": "Street View",
        "soleAgent": "Sole Agent",
        "video": "Videos",
        "photo": "Photos",
        "neighbouthood": "Neighbourhood",
        "back": "Back To The Property",
        forSale: "",
        forRent: "",
        save: "",
        share: "",
        sqft: "",
        sa: "",
        gfa: "",
        beds: "",
        baths: "",
        id: "",
        ref: "",
        updated: "",
        layout: "",
        floor: "",
        floorRise: "",
        features: "",
        buildingAge: "",
        buildingType: "",
        facilities: "",
        years: "",
        contact: "",
        contactAgent: "",
        mapview: "",
        streetview: "Street View",
        startvr: "",
        myPlaces: "",
        properties: "",
        schools: "",
        more: "",
        enterLocation: "",
        min: "",
        hour: "",
        saveThisPlace: "",
        virtualTour: "",
        virtualTourCaption: "",
        wantToList: "",
        listYourProperty: "",
        mortgage: "",
        propertyValue: "",
        downPayment: "",
        duration: "",
        hkBuyer: "",
        ownsProperty: "",
        hasTransactedRecently: "",
        month: "",
        interestRate: "",
        insurance: "",
        customizeCalculation: "",
        monthlyPayment: "",
        totalCashOutlay: "",
        explore: "",
        avg: "",
        viewDetails: "",
        similarProperties: "",
        districtGuide: "",
        featureAndFacilities: "",
        viewMore: "",
        custom: "",
        yrs: "",
        perMonth: "",
        keepUpdateWith: "",
        follow: "",
        searchProperties: "",
        vr: "",
        floorPlan: "",
        addPlace: "",
        results: "",
        direction: "",
        view: "",
        bd: "",
        ba: "",
        savedPlaces: "",
        followings: "",
        history: "",
        essentials: "",
        banksAtm: "",
        hospital: "",
        commute: "",
        railwaysMtr: "",
        busStop: "",
        lifestyle: "",
        restaurant: "",
        convenienceStores: "",
        nearbyProperties: "",
        noSavedPlaceYet: "",
        startAddingNewPlace: "",
        getTravelTime: "",
        startSavingNewPlace: "",
        login: "",
        hkd: "",
        principlePlaceholder: "",
        downPaymentPlaceholder: "",
        downPaymentPercentPlaceholder: "",
        durationPlaceholder: "",
        interestPlaceholder: "",
        percent: "",
        interest: "",
        stampDuty: "",
        commission: "",
        totalExpense: "",
        calculate: "",
        overview: "",
        schedule: "",
        rateTable: "",
        minimumIncome: "",
        totalExpenseBreakdown: "",
        principle: "",
        total: "",
        mortgageSummary: "",
        monthlyExpense: "",
        assumedIntrestRate: "",
        stressTest: "",
        initialTotalCashOutlay: "",
        noMonth: "",
        payment: "",
        balance: "",
        year: "",
        saved: "",
        unfollow: "",
        unavailbleKey: "",
        unavailbleValue: "",
        unavailbleLink: "",
        findOutMoreAbout: "",
        message: "",
        subjectToOffer: "",
        interactiveMap: "",
        mortgageDisclaimer: "",
        whatsappText: "",
        addPlaceKeyword: "",
        addPlaceNoResults: "",
        noPhoto: "",
        viewPropreties: "",
        excludeManagementFee: "",
        includeManagementFee: "",
        carparks: "",
        covered: "",
        uncovered: "",
        excludeCarpark: "",
        includeCarpark: "",
        favorites: "",
        noResults: "",
        forSaleRent: "",
        sameBuildingProperties: "",
        floorPlanDisclaimer: "",
        sold: "",
        telNo: ""
    },
    "showPanel": false,
    hasVr: false,
    hasFloorPlan: false,
    popRender: false,
    videos: []
};
